var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveBgPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "#1790FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: ""
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.125 8.95048H19.8193V8.94751C19.8193 8.4218 19.4004 7.99707 18.8818 7.99707H14.1182C13.5996 7.99707 13.1807 8.4218 13.1807 8.94751V8.95048H10.875C10.3564 8.95048 9.9375 9.3752 9.9375 9.90091C9.9375 10.4266 10.3564 10.8513 10.875 10.8513H22.125C22.6436 10.8513 23.0625 10.4266 23.0625 9.90091C23.0625 9.3752 22.6436 8.95048 22.125 8.95048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6104 24.006H12.3896C11.5576 24.006 10.8809 23.3229 10.8809 22.4764V13.3284C10.8809 12.4849 11.5547 11.7988 12.3896 11.7988H20.5869C21.4336 11.7988 22.1191 12.4938 22.1191 13.3522V22.4764C22.1162 23.3199 21.4424 24.006 20.6104 24.006Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 16,
    fill: "white",
    transform: "translate(9 8)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveBgPrimary);
export default __webpack_public_path__ + "static/media/removeBGPrimary.c3bcee9d.svg";
export { ForwardRef as ReactComponent };